import {
  backDropDiv,
  closeIcon,
  errorBanner,
  okBtn,
  locationIdErrorBanner,
  warningBanner,
} from "../constants/elements";
export const startError = (errors: any, metaData: any): void => {
  // backDropDiv.className = "retail-error-banner-background";
  backDropDiv.style.display = "block";
  let errorResp: any;
  if (errors && errors.length > 0) {
    errorResp = errors[0]?.messages[0];
  }
  const locationId = new URLSearchParams(window.location.search).get("locationId");
  const locPostalCode = document.querySelector("[rsmonitor='location_response_postalCode']");
  const locPostalCodeValue = locPostalCode?.getAttribute("value");
  if (errorResp && errorResp.indexOf("appointment slot unavailable") !== -1) {
    warningBanner.style.display = "flex";
    // const warningBanner: any = document.getElementById("goToDateAndTimePage");
    // if (warningBanner) {
    //   warningBanner.style.display = "flex";
    // }
    backDropDiv.style.display = "retail-error-banner-background";
  } else if (metaData.stepName && metaData.stepName.toLowerCase() === "launch screen") {
    if (!locationId || !locPostalCodeValue || locPostalCodeValue === "") {
      locationIdErrorBanner.style.display = "flex";
    }
  } else if (!locationId) {
    locationIdErrorBanner.style.display = "flex";
  } else {
    errorBanner.style.display = "flex";
  }
  if (closeIcon) {
    closeIcon.addEventListener("click", function () {
      errorBanner.style.display = "none";
      backDropDiv.style.display = "none";
    });
  }
  if (okBtn) {
    okBtn.addEventListener("click", function () {
      warningBanner.style.display = "none";
      const timeAndDatePage: any = document.getElementById("goToDateAndTimePage");
      timeAndDatePage.click();
    });
  }
};
